import { VStack, HStack, Text, Divider } from "@chakra-ui/layout";

import { $length, $ok } from "foundation-ts/commons";
import { Nullable } from "foundation-ts/types";

import { Step, SubscriptionType } from "./RegisterTypes";

interface StepSummaryProps {
    step: Step;
    // Subscription
    selectedSubscription: Nullable<SubscriptionType>;
    isAloneUser: Nullable<boolean>;
    nbCollaborators: number;
    amount: Nullable<number>;
    partnerCode: string;
    // Account
    lastname: string;
    firstname: string;
    email: string;
    organizationName: string;
    organizationIdentifier?: string;
    // Billing
    tvaIntra: string;
}

export const StepSummary = ({
    step,
    selectedSubscription,
    isAloneUser,
    nbCollaborators,
    amount,
    partnerCode,
    lastname,
    firstname,
    email,
    organizationName,
    organizationIdentifier,
    tvaIntra,
}: StepSummaryProps) => {
    switch (step) {
        case "subscription":
            return (
                <VStack align="flex-start" spacing={1} px={6} pb={4} fontSize="sm">
                    <HStack>
                        <Text fontWeight="semibold" color="gray.500">Abonnement :</Text>
                        <Text>{selectedSubscription === "limited" ? 60 : "Illimité"}</Text>
                        <Text fontWeight="semibold" color="gray.700">
                            {selectedSubscription === "limited" ? "109€ HT/an" : "180€ HT/an"}
                        </Text>
                    </HStack>
                    {isAloneUser === false && nbCollaborators > 0 && (
                        <HStack>
                            <Text fontWeight="semibold" color="gray.500">Collaborateurs :</Text>
                            <Text>{nbCollaborators} × 60€ HT</Text>
                        </HStack>
                    )}
                    {$length(partnerCode) > 0 && (
                        <HStack>
                            <Text fontWeight="semibold" color="gray.500">Code partenaire :</Text>
                            <Text>{partnerCode}</Text>
                        </HStack>
                    )}
                    <Divider />
                    <HStack>
                        <Text fontWeight="bold" color="gray.600">Total :</Text>
                        <Text fontWeight="bold" color="green.500">{amount}€ HT/an</Text>
                    </HStack>
                </VStack>
            );

        case "account":
            return (
                <VStack align="flex-start" spacing={1} px={6} pb={4} fontSize="sm">
                    <HStack>
                        <Text fontWeight="semibold" color="gray.500">Nom :</Text>
                        <Text>{lastname} {firstname}</Text>
                    </HStack>
                    <HStack>
                        <Text fontWeight="semibold" color="gray.500">Email :</Text>
                        <Text>{email}</Text>
                    </HStack>
                    <HStack>
                        <Text fontWeight="semibold" color="gray.500">Organisation :</Text>
                        <Text>{organizationName}</Text>
                    </HStack>
                    {$ok(organizationIdentifier) && (
                        <HStack>
                            <Text fontWeight="semibold" color="gray.500">Identifiant :</Text>
                            <Text>{organizationIdentifier}</Text>
                        </HStack>
                    )}
                </VStack>
            );

        case "billing":
            return (
                <VStack align="flex-start" spacing={1} px={6} pb={4} fontSize="sm">
                    <HStack>
                        <Text fontWeight="semibold" color="gray.500">TVA intracommunautaire :</Text>
                        <Text>{tvaIntra}</Text>
                    </HStack>
                </VStack>
            );

        default:
            return null;
    }
};